import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import "../PlanimetriaIcons.css";
import {
  aggiornaElementoPlaceholderMappa,
  creaElementoMappa,
} from "../../../functions/creaElementoMappa";
import { iconSelectedElement } from "../../../const/Planimetria/IconPlanimetria";
import Notification from "../../UI/Notification/Notification";
import ElementSubMenu from "../SubMenu/ElementSubmenu";
import { DISPONIBILE } from "../../../const/Planimetria/StatoPostazione";
import {
  aggiustamentiMenuContestualePlanimetriaPrenotazione,
  aggiustamentiPlanimetriaPrenotazione,
} from "../../../const/Planimetria/gestionePlanimetria";
import sfondoDefault from "../../../assests/sfondoPlanimetriaDefault.png";
import { savePostazioneCompletoInPrenotazioneStepper, saveStanzaCompletoInPrenotazioneStepper } from "../../../redux/reducers/infoPrenotazione-reducer";
import useNoPassiveEventListener from "../../../Hooks/useNoPassiveEventListener";
import useScrollGrabOnContainer from "../../../Hooks/useScrollGrabToContainer/useScrollGrabOnContainer";
import { addDoubleClickEvent } from "../../../functions/Utils/addDoubleClickEvent";
import { handlerMobileZoom, handlerScale } from "../../../functions/handlerZoom";
import useMobileDetection from "../../../Hooks/useMobileDetection";
import { calcolaPercentualeDiMarginDaScaleImage } from "../../../functions/calcolaScaleImageDelloZoom";
import ShowTips from "../../showTips/showTips";
import { initialValueScaleZoomDesktop, initialValueScaleZoomMobile } from "../../../const/Planimetria/valueScaleZoomPlanimetria";
import { containerClass } from "../../../const/Planimetria/costantiPlanimetria";
import handlerConfiguration from "../../../functions/general/handlerConfiguration";
import PartecipantiRiunione from "./PartecipantiRiunione/PartecipantiRiunione";
import { handlerUtentiPrenotazione } from "../../../redux/reducers/prenotazioneStepper-reducer";
import { selectUserInMultiUser } from "../../../redux/reducers/MultiUserInStepper-reducer";
import { notificationOpen } from "../../../redux/reducers/notification-reducer";
import AvatarImage from "../../Avatar/AvatarImage";
import ShowDispositiviOnPlanimetria from "./legenda/ShowDispositiviOnPlanimetria";
import calcoloGrandezzaContainer from "../../../functions/planimetria/calcoloGrandezzaContainer";
import { ApplyScalePlanimetria, IncrementaDimensioneImageAlloZoom, IncrementaDimensioneValoreAlloZoom } from "../../../functions/planimetria/applyScalePlanimetria";
import checkScroll from "../../../functions/planimetria/checkScroll";
import responsiveImagePlanimetria from "../../../functions/planimetria/ResponsiveImagePlanimetria";

export const idMainComponent = "main-component";
export const idDialogPadre = "dialog-stepper";

const grandezzaIcona = 24;
const PropStanza = "posto";
const msgAvvisoSelezioneUtente = "Per procedere con la prenotazione di una postazione, è necessario selezionare un utente";
const componentName = "PlanimetriaPrenotazione";
const sectionEnabled = false;

/**
 * Calcola la scala "contain" per adattare l'immagine al container
 * mantenendo l'aspect ratio (come CSS object-fit: contain).
 */
function calcolaFitScale(imgW, imgH, containerW, containerH) {
  if (!imgW || !imgH || !containerW || !containerH) return 1;
  const parsed = (v) => (typeof v === "string" ? parseFloat(v) : v);
  const cw = parsed(containerW);
  const ch = parsed(containerH);
  return Math.min(cw / imgW, ch / imgH);
}

export default function PlanimetriaPrenotazine({
  elementiDalDb = [],
  typePage = "",
  imageBackground,
  actionOnClickButton,
  dettaglioSfondoPlanimetria = {},
  disableAutoSelect = false,
  heightBonus = 0,
  containerDimensionsOverride = null,
}) {
  const configurations = useSelector((state) => state.configurations);
  const abilitaPrenotazioneMultiplaSalaRiunioni = configurations.configurazioniPrenotazione.abilitaPrenotazioneMultiplaSalaRiunioni;

  const {
    utentePrenotazione: utentiEPostazioneDaInserire,
    partecipantiRiunione,
    titoloRiunione
  } = useSelector((state) => state.prenotazioneStepper);

  const infoPrenotazioneStepper = useSelector(
    (state) => state.prenotazioneStepper
  );

  const {
    larghezzaPlanimetriaDefault: PlanimetriaLarghezza,
    altezzaPlanimetriaDefault: PlanimetriaAltezza,
  } = handlerConfiguration(configurations);

  const isMobile = useMobileDetection();
  const refContainerDropzone = useRef(null);
  const dispatch = useDispatch();
  const refImage = useRef(null);
  const [selected, setSelected] = useState(-1);
  const [statusScrollPlanimetria, setStatusScrollPlanimetria] = useState({});
  const [elementiRecuperati, setElementiRecuperati] = useState([]);
  const [dettaglioSalaRiunione, setDettaglioSalaRiunione] = useState(undefined);
  const [titoloRiunioneSala, setTitoloRiunioneSala] = useState("");
  const isSecondRender = useRef(false);
  const [forzaRerenderPerAggiornamentoDom, setForzaRerenderPerAggiornamentoDom] = useState(false);
  const [ospitiDaInserireInSalaRiunione, setOspitiDaInserireInSalaRiunione] = useState([]);
  const [isOpenSubmenu, setIsOpenSubmenu] = useState(false);
  const userSelectedInStepper = useSelector(
    (state) => state.multiUserHandlerInStepper
  );

  // null = scala non ancora calcolata; verrà impostata dal useEffect di fit
  const [scaleZoom, setScaleZoom] = useState(null);

  // ─── Ref che tiene traccia del fitScale corrente ───────────────────────────
  // Serve per clampare lo zoom-out senza dover passare fitScale come dipendenza
  // al setter usato da useNoPassiveEventListener (che non può essere ricreato
  // ad ogni render senza rimuovere/riaddestrare il listener).
  const minScaleRef = useRef(null);

  /**
   * Wrapper di setScaleZoom che impedisce allo zoom-out di scendere
   * sotto il fitScale calcolato (comportamento "contain" come scala minima).
   */
  const setScaleZoomClamped = (valueOrUpdater) => {
    setScaleZoom((prev) => {
      const next =
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev)
          : valueOrUpdater;
      const min = minScaleRef.current;
      if (min != null && next != null && next < min) return min;
      return next;
    });
  };

  const [infoPrenotazioniToSubmenu, setinfoPrenotazioniToSubmenu] = useState([]);
  const [infoPositionSubMenuAndId, setInfoPositionSubMenuAndId] = useState({
    id: 0,
    x: 0,
    y: 0,
    status: 0,
    descrizioneStatus: "Disponibile",
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [initDimensioneWidth, setInitDimensioneWidth] = useState(0);
  const [initDimensioneHeight, setInitDimensioneHeight] = useState(0);

  const {
    altezzaPlanimetria,
    larghezzaPlanimetria,
    idSfondoPlanimetria,
    isSalaRiunione,
  } = dettaglioSfondoPlanimetria;

  // ─── DICHIARAZIONE ANTICIPATA ──────────────────────────────────────────────
  const [larghezzaContainer, altezzaContainer] = containerDimensionsOverride
    ? [containerDimensionsOverride.larghezza, containerDimensionsOverride.altezza]
    : calcoloGrandezzaContainer(idDialogPadre, isMobile, idMainComponent);

  const parsedContainerW = typeof larghezzaContainer === "string"
    ? parseFloat(larghezzaContainer)
    : (larghezzaContainer || 0);

  const parsedContainerH = typeof altezzaContainer === "string"
    ? parseFloat(altezzaContainer)
    : (altezzaContainer || 0);
  // ──────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    setIsOpenSubmenu(false);
    let elementiDaMostrare = elementiDalDb.map((el) => {
      return {
        element: creaElementoMappa(el, true, userSelectedInStepper, infoPrenotazioneStepper.ripetizioneStatus, abilitaPrenotazioneMultiplaSalaRiunioni),
        ...el,
      };
    });

    let elementi = elementiDaMostrare;

    if (
      elementiDaMostrare.length > 0 &&
      elementiDaMostrare.every((x) => x.hasOwnProperty(PropStanza))
    ) {
      elementi = utentiEPostazioneDaInserire.some(
        (x) => x.posto != null || undefined
      )
        ? aggiornaStatoPostazioniPlanimetriaConPrenotazioniInCorso(
          utentiEPostazioneDaInserire,
          elementiDaMostrare,
          userSelectedInStepper
        )
        : elementiDaMostrare;

      if (
        userSelectedInStepper.posto &&
        elementi[0]?.idStanza === userSelectedInStepper?.idStanza
      ) {
        setSelected({ index: userSelectedInStepper.index, status: 1 });
        dispatch(
          savePostazioneCompletoInPrenotazioneStepper({
            posto: userSelectedInStepper.posto,
          })
        );
      } else {
        setSelected(-1);
      }
    }
    setElementiRecuperati(elementi);
  }, [elementiDalDb, userSelectedInStepper]);

  function aggiornaStatoPostazioniPlanimetriaConPrenotazioniInCorso(
    utentiEPostazioneDaInserire = [],
    elementiRecuperati = [],
    userSelectedInStepper = null
  ) {
    let arr = utentiEPostazioneDaInserire.filter(
      (x) => x.posto != null || undefined
    );

    if (!arr.length) return null;

    let elementiDaModificare = arr.filter((x) => {
      let result = elementiRecuperati.filter((y) => x.posto === y.posto);
      if (result) {
        return x;
      }
    });

    if (
      !elementiDaModificare.length ||
      !elementiRecuperati.length ||
      !elementiRecuperati.every((x) => x.hasOwnProperty("posto"))
    )
      return null;

    let result = aggiornaElementoPlaceholderMappa(
      elementiRecuperati,
      elementiDaModificare,
      userSelectedInStepper,
      infoPrenotazioneStepper,
      utentiEPostazioneDaInserire
    );

    return result;
  }

  function openSubmenu(event, id, descrizioneStatus, status, selectedElement) {
    event.preventDefault();
    event.stopPropagation();

    setAnchorEl(event.currentTarget);

    if (elementiRecuperati[selectedElement?.index] !== undefined) {
      const { prenotazioni } = elementiRecuperati[selectedElement.index];

      setInfoPositionSubMenuAndId((prev) => {
        prev.id == id
          ? setIsOpenSubmenu(!isOpenSubmenu)
          : setIsOpenSubmenu(true);

        return {
          id,
          status,
          descrizioneStatus,
          isSalaRiunione: elementiRecuperati[selectedElement?.index]?.isSalaRiunione,
          x:
            event.screenX +
            refContainerDropzone?.current?.scrollLeft -
            refContainerDropzone.current.parentElement.parentElement
              .parentElement.parentElement.parentElement.parentElement
              .parentElement.offsetLeft -
            aggiustamentiPlanimetriaPrenotazione.aggiustamentoPosizioneLeftSuPlanimetriaPrenotazione +
            aggiustamentiMenuContestualePlanimetriaPrenotazione.aggiustamentoPosizioneLeftSuMenuContestualePlanimetriaPrenotazione,
          y:
            event.screenY -
            refContainerDropzone.current.parentElement.parentElement
              .parentElement.parentElement.parentElement.parentElement
              .parentElement.offsetTop +
            refContainerDropzone?.current?.scrollTop -
            aggiustamentiPlanimetriaPrenotazione.aggiustamentoPosizioneTopSuPlanimetriaPrenotazione,
        };
      });

      setinfoPrenotazioniToSubmenu(prenotazioni);
    }
  }

  function onClickIcon(event, index, el) {
    const {
      id,
      status,
      statusDescrizione,
      postazioniDisponibili,
      posto,
      idStanza,
    } = el;

    if (openSubmenuSalaRiunioniRipetizione(event, el, id, statusDescrizione, status)) {
      return;
    }

    if (el.idZona != undefined) {
      dispatch(
        saveStanzaCompletoInPrenotazioneStepper({
          id: el.id,
          sigla: el.sigla,
          denominazione: el.denominazione,
          isSalaRiunione: el.isSalaRiunione,
        })
      );
    }

    let selectedElement = actionOnClickButton(
      event,
      id,
      index,
      el.posto,
      status,
      postazioniDisponibili
    );

    if (status == DISPONIBILE) {
      if (
        Object.keys(userSelectedInStepper).length === 0 &&
        infoPrenotazioneStepper.radioButtonPrenotazionePerAltri &&
        infoPrenotazioneStepper.utentePrenotazione.length > 0
      ) {
        dispatch(
          notificationOpen({
            message: msgAvvisoSelezioneUtente,
            status: "warning",
          })
        );
        return;
      }

      setSelected({ index: selectedElement.index, status });

      dispatch(
        selectUserInMultiUser({
          ...userSelectedInStepper,
          posto: selectedElement.posto,
          idStanza: idStanza,
          index: selectedElement.index,
        })
      );

      dispatch(
        savePostazioneCompletoInPrenotazioneStepper({
          posto,
          index: selectedElement.index,
        })
      );

      const utenteConPostoAssociato = {
        ...userSelectedInStepper,
        idStanza,
        posto,
        id,
        index: selectedElement.index,
      };

      dispatch(handlerUtentiPrenotazione(utenteConPostoAssociato));
    } else {
      if (event)
        openSubmenu(event, id, statusDescrizione, status, selectedElement);
    }
  }

  function onTouchMobile(event, index, el) {
    event.preventDefault();
    event.stopPropagation();

    const { id, status, statusDescrizione, postazioniDisponibili, posto } = el;

    if (openSubmenuSalaRiunioniRipetizione(event, el, id, statusDescrizione, status)) {
      return;
    }

    if (el.idZona != undefined) {
      dispatch(
        saveStanzaCompletoInPrenotazioneStepper({
          id: el.id,
          sigla: el.sigla,
          denominazione: el.denominazione,
          isSalaRiunione: el.isSalaRiunione,
        })
      );
    }

    let selectedElement = actionOnClickButton(
      event,
      id,
      index,
      posto,
      status,
      postazioniDisponibili
    );

    if (status == DISPONIBILE) {
      setSelected({ index: selectedElement?.index, status });
      dispatch(
        selectUserInMultiUser({
          ...userSelectedInStepper,
          posto: selectedElement?.posto,
          idStanza: el.idStanza,
          index: selectedElement?.index,
        })
      );

      dispatch(savePostazioneCompletoInPrenotazioneStepper({ posto }));
      const utenteConPostoAssociato = { ...userSelectedInStepper, posto, id };
      dispatch(handlerUtentiPrenotazione(utenteConPostoAssociato));
    } else {
      openSubmenu(undefined, id, statusDescrizione, status, selectedElement);
    }
  }

  function openSubmenuSalaRiunioniRipetizione(event, el, id, statusDescrizione, status) {
    if (el.isSalaRiunione && infoPrenotazioneStepper.ripetizioneStatus && !abilitaPrenotazioneMultiplaSalaRiunioni) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setinfoPrenotazioniToSubmenu(el.prenotazioni ?? []);
        setInfoPositionSubMenuAndId((prev) => {
          prev.id === id ? setIsOpenSubmenu(!isOpenSubmenu) : setIsOpenSubmenu(true);
          return { id, status, descrizioneStatus: statusDescrizione, x: 0, y: 0, isSalaRiunione: el.isSalaRiunione };
        });
      }
      return true;
    }
    return false;
  }

  // Auto-selezione se presente un solo elemento disponibile
  useEffect(() => {
    if (
      !disableAutoSelect &&
      utentiEPostazioneDaInserire.length <= 1 &&
      elementiRecuperati?.length === 1 &&
      selected === -1 &&
      elementiRecuperati[0].status === 1
    ) {
      let el = elementiRecuperati[0];
      el.prenotazioni = [];
      el.status = 1;
      onClickIcon(null, 0, el);
    }

    if (dettaglioSfondoPlanimetria.isSalaRiunione) {
      const idPostazioneSalaRiunione = elementiDalDb[0].id;
      setOspitiDaInserireInSalaRiunione(
        partecipantiRiunione[idPostazioneSalaRiunione]
      );

      let keyIdPostazioneTitoloRiunione = Object.keys(titoloRiunione);

      let indexTitolo = keyIdPostazioneTitoloRiunione.map((x, index) => {
        if (x == idPostazioneSalaRiunione) {
          return index;
        }
      });

      let filteredIndexTitolo = indexTitolo.filter((x) => x !== undefined)[0];
      let idPostazioneSala = keyIdPostazioneTitoloRiunione[filteredIndexTitolo];
      let objTitolo = titoloRiunione[idPostazioneSala];
      if (objTitolo) setTitoloRiunioneSala(objTitolo);

      setDettaglioSalaRiunione(elementiDalDb[0]);
    }
  }, [elementiRecuperati, userSelectedInStepper, titoloRiunione]);

  // Calcola la scala fit-contain ogni volta che cambiano le dimensioni dell'immagine o del container.
  // Aggiorna anche minScaleRef così il clamp è sempre allineato al fitScale corrente.
  useEffect(() => {
    const imgW = larghezzaPlanimetria || PlanimetriaLarghezza;
    const imgH = altezzaPlanimetria || PlanimetriaAltezza;
    if (!imgW || !imgH || !parsedContainerW || !parsedContainerH) return;

    const fitScale = calcolaFitScale(imgW, imgH, parsedContainerW, parsedContainerH);

    // Aggiorna il ref PRIMA di impostare lo stato, così il setter clamped
    // usa già il nuovo minimo anche nella stessa chiamata sincrona.
    minScaleRef.current = fitScale;

    setScaleZoom((prev) => {
      // Se è il primo calcolo (prev === null) oppure lo zoom attuale è già
      // sotto il nuovo minimo, resetta al fitScale.
      if (prev === null || prev < fitScale) return fitScale;
      return prev;
    });
  }, [
    larghezzaPlanimetria,
    altezzaPlanimetria,
    PlanimetriaLarghezza,
    PlanimetriaAltezza,
    parsedContainerW,
    parsedContainerH,
  ]);



  function closeMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    setIsOpenSubmenu(false);
  }

  function stopEvent(event) {
    event.stopPropagation();
  }

  useScrollGrabOnContainer(refContainerDropzone, refImage);

  // Scala effettiva: usa il fit calcolato oppure il default nel caso in cui
  // le dimensioni non siano ancora disponibili (primo render)
  const effectiveScale = scaleZoom ?? (isMobile ? initialValueScaleZoomMobile : initialValueScaleZoomDesktop);

  // Dimensioni immagine originale
  const imgW = larghezzaPlanimetria || PlanimetriaLarghezza;
  const imgH = altezzaPlanimetria || PlanimetriaAltezza;

  // Dimensioni immagine scalata (fit-contain)
  const scaledWidth = imgW * effectiveScale;
  const scaledHeight = imgH * effectiveScale;

  // Margini per centrare l'immagine scalata nel container
  const centerMarginLeft = Math.max(0, (parsedContainerW - scaledWidth) / 2);
  const centerMarginTop = Math.max(0, (parsedContainerH - scaledHeight) / 2);

  // Aggiorna initDimensione per compatibilità con useNoPassiveEventListener
  useEffect(() => {
    setInitDimensioneWidth(scaledWidth + centerMarginLeft);
    setInitDimensioneHeight(scaledHeight + centerMarginTop);
  }, [scaledWidth, scaledHeight, centerMarginLeft, centerMarginTop]);

  // Gestisce l'aggiornamento del DOM tramite due render
  useEffect(() => {
    if (isSecondRender.current) {
      let statusScroll = checkScroll(refContainerDropzone);
      setStatusScrollPlanimetria(statusScroll);
      isSecondRender.current = false;
    } else {
      setForzaRerenderPerAggiornamentoDom(prev => !prev);
      isSecondRender.current = true;
    }
  }, [effectiveScale, forzaRerenderPerAggiornamentoDom, centerMarginTop, centerMarginLeft, scaledWidth, scaledHeight]);

  useNoPassiveEventListener(refImage, "wheel", setScaleZoom, statusScrollPlanimetria, minScaleRef);

  return (
    <React.Fragment>
      <style>{`.container-map::-webkit-scrollbar { display: none; }`}</style>
      <Grid container className={true ? "" : "dontshow"}>
        <Grid item xs={12} sm={12} id={idMainComponent}>
          <div
            className="container-map"
            style={{
              // Su mobile, quando l'immagine zoomata supera il container,
              // abilita lo scroll nativo touch invece di nascondere il contenuto
              overflowX: isMobile && scaledWidth > parsedContainerW ? "auto" : "hidden",
              overflowY: isMobile && scaledHeight > parsedContainerH ? "auto" : "hidden",
              maxWidth: "100%",
              height: parsedContainerH,
              width: parsedContainerW,
              // Scroll inerziale iOS (momentum scrolling)
              WebkitOverflowScrolling: "touch",
              // Nasconde la scrollbar visivamente mantenendo lo scroll touch
              scrollbarWidth: "none",        // Firefox
              msOverflowStyle: "none",       // IE/Edge legacy
            }}
            ref={refContainerDropzone}
          >
            {Object.keys(dettaglioSfondoPlanimetria).length !== 0 && (
              /*
               * SPACER WRAPPER
               * ──────────────
               * transform: scale() è puramente visivo: il browser continua a
               * vedere il div con le dimensioni ORIGINALI (non scalate), quindi
               * il container non genera mai la scrollbar.
               * Lo spacer occupa lo spazio REALE corrispondente alle dimensioni
               * scalate, così il container "vede" il contenuto più grande e
               * attiva automaticamente overflow-x: auto quando serve.
               * Su desktop lasciamo il comportamento invariato (width/height "auto").
               */
              <div
                style={{
                  position: "relative",
                  width: isMobile ? `${scaledWidth}px` : "100%",
                  height: isMobile ? `${scaledHeight}px` : "100%",
                  flexShrink: 0,
                }}
              >
                <div
                  className={containerClass}
                  ref={refImage}
                  style={{
                    position: "absolute", // era "relative" — ora si appoggia allo spacer
                    top: 0,
                    left: 0,
                    marginLeft: `${centerMarginLeft}px`,
                    marginTop: `${centerMarginTop}px`,
                    transform: `scale(${effectiveScale})`,
                    transformOrigin: "top left",
                    backgroundImage: idSfondoPlanimetria
                      ? `url(${imageBackground})`
                      : `url(${sfondoDefault})`,
                    height: `${imgH + heightBonus}px`,
                    width: `${imgW}px`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                  }}
                  onClick={(e) =>
                    addDoubleClickEvent(
                      e,
                      { function: closeMenu },
                      {
                        function: handlerMobileZoom,
                        params: {
                          saveStateFunction: setScaleZoom,
                          refContainer: refContainerDropzone,
                          minScale: minScaleRef.current,
                        },
                      },
                      { ableToDesktop: false, isMobile, timer: 200 }
                    )
                  }
                >
                  {elementiRecuperati?.map((el, index) => {
                    let isAvatar =
                      el.prenotazioni?.[0]?.utentePrenotatoFullname != null &&
                      el.prenotazioni?.every(
                        (x) =>
                          x.utentePrenotato ===
                          el.prenotazioni?.[0].utentePrenotato
                      );
                    return (
                      <Draggable
                        onStart={() => false}
                        position={{ x: el.posX, y: el.posY }}
                        key={index}
                      >
                        <div
                          className={el.element.style}
                          style={{
                            position: "absolute",
                            width: `${grandezzaIcona}px`,
                            height: `${grandezzaIcona}px`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: isAvatar ? "#fff" : "",
                          }}
                          onClick={(event) => onClickIcon(event, index, el)}
                          onTouchStart={(event) => onTouchMobile(event, index, el)}
                          onTouchStartCapture={(event) => stopEvent(event)}
                        >
                          {el?.idStanza && (
                            <ShowDispositiviOnPlanimetria el={el} />
                          )}
                          {selected.index === index &&
                            selected.status === DISPONIBILE ? (
                            iconSelectedElement
                          ) : isAvatar ? (
                            <AvatarImage
                              isOspite={el.prenotazioni?.[0].ospite}
                              size={34}
                              bgColor={"#ad3a3a"}
                              ImmagineAvatar={
                                el.prenotazioni.length >= 1
                                  ? el.prenotazioni?.[0].immagineAvatar
                                  : null
                              }
                              isUserLoggedImage={false}
                              isCentered={false}
                              isInputDisabled={true}
                              name={
                                el.prenotazioni?.[0].ospite
                                  ? el.prenotazioni?.[0].nominativoOspite
                                  : el.prenotazioni?.[0].utentePrenotatoFullname
                              }
                            />
                          ) : (
                            el.element.icon
                          )}
                        </div>
                      </Draggable>
                    );
                  })}
                  <ElementSubMenu
                    open={isOpenSubmenu}
                    mostraTasti={false}
                    infoPrenotazioniToSubmenu={infoPrenotazioniToSubmenu}
                    infoPositionSubMenuAndId={infoPositionSubMenuAndId}
                    typeComponent={typePage}
                    anchorEl={anchorEl}
                    isSalaRiunione={
                      infoPositionSubMenuAndId.isSalaRiunione ?? isSalaRiunione
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      <Notification />
      {isMobile && <ShowTips parent={componentName} />}
      {sectionEnabled && isSalaRiunione && elementiDalDb[0].status === DISPONIBILE ? (
        <PartecipantiRiunione
          ospitiDaPrenotazioneStepper={ospitiDaInserireInSalaRiunione}
          salaRiunione={dettaglioSalaRiunione}
          titoloRiunione={titoloRiunioneSala}
        />
      ) : null}
    </React.Fragment>
  );
}